<template>
  <BasicModal
    :title="getTitle()"
    :isShowModal="isShowModal"
    :canCancel="false"
    @cancel="cancel">
    <div class="-container" v-if="recordingInterview">
      <div class="input-field">
        <p>録画面接名</p>
        <input class="input" max-length="300" v-model="recordingInterview.name"/>
      </div>
      <div class="input-field">
        <p>説明</p>
        <textarea class="textarea" max-length="500" v-model="recordingInterview.description"></textarea>
      </div>
      <div class="input-field">
        <p>面接可能時間帯</p>
        <div class="time-field">
          <b-timepicker
            v-model="recordingInterview.start_hhmm"
            hour-format="24"
            class="-time"
            placeholder="開始"
            icon="clock"
            :enable-seconds="false"
            :locale="'ja-JP'"
            :max-time="recordingInterview.end_hhmm">
          </b-timepicker>
          <span class="-left-8px -right-8px">～</span>
          <b-timepicker
            v-model="recordingInterview.end_hhmm"
            hour-format="24"
            class="-time"
            placeholder="終了"
            icon="clock"
            :enable-seconds="false"
            :locale="'ja-JP'"
            :min-time="recordingInterview.start_hhmm">
          </b-timepicker>
        </div>
      </div>
      <div class="input-field">
        <p>全体の制限時間</p>
        <p style="display: flex; align-items: center;">
          <b-numberinput :editable="false" v-model="recordingInterview.total_limit_time" step="1" min="1" max="120" controls-position="compact"></b-numberinput>
          <span class="-left-8px">分</span>
        </p>
      </div>
      <div class="input-field">
        <p>鏡像撮影</p>
          <b-switch v-model="mirrorImage">{{mirrorImage ? 'ON' : 'OFF'}}</b-switch>
      </div>
      <div style="display: inline-block; width: 100%;" v-for="(movie, idx) in recordingInterview.recording_content" :key=idx>
        <hr>
        <div class="input-field">
          <p>質問<b>{{(Number(movie.order) + 1)}}</b>のタイトル</p>
          <input class="input" max-length="500" v-model="movie.name"/>
          <p>質問<b>{{idx + 1}}</b>の回答時間</p>
          <p style="display: flex; align-items: center;">
            <b-numberinput :editable="false" v-model="movie.answer_time" step="15" min="15" max="360" controls-position="compact"></b-numberinput>
            <span class="-left-8px">秒</span>
          </p>
          <p>質問<b>{{idx + 1}}</b>の再再生選択可能時間</p>
          <p style="display: flex; align-items: center;">
            <b-numberinput :editable="false" v-model="movie.replayable_time" step="5" min="10" max="360" controls-position="compact"></b-numberinput>
            <span class="-left-8px">秒</span>
          </p>
        </div>
        <div class="input-field">
          <!-- 録画ファイルがない場合は録画開始画面 -->
          <b-switch
            v-model="videoInfo[idx].isCameraActive"
            @input="cameraSwitch(idx)"
            :disabled="isRecording(idx)"
            v-if="!movie.question_recording"
          >
            カメラ{{videoInfo[idx].isCameraActive ? 'ON' : 'OFF'}}
          </b-switch>
          <b-progress
            type="is-success"
            style="margin-bottom: 8px;"
            :max="180" :value="timer" show-value
            v-if="isRecording(idx)">
            {{timer}}秒 経過
          </b-progress>
          <div class="video-wrapper">
            <div class="question-title" v-if="idx >= 0">
              質問<b>{{idx + 1}}</b>
            </div>
            <template v-if="!movie.question_recording">
              <video :class="{'video-flip': mirrorImage === true}" class="video-back" :id="'question-' + idx" autoplay muted/>
              <div class="start-button" @click="startRecording(idx)" v-if="!isRecording(idx)">
                <p>
                  <span class="mdi mdi-play -right-4px"></span>
                  録画を開始（最大3分）
                </p>
                <span class="desc">カメラをONにすると録画が可能になります。</span>
                <span class="desc">クリックすると録画が即座に開始されます。</span>
                <span class="desc">ハウリング防止のためマイクをお使いいただくことを推奨いたします。</span>
              </div>
            </template>
            <!-- 録画ファイルがある場合はそれを再生する画面 -->
            <template v-else>
              <RecordingVideoTag
                mode="edit"
                :index="idx"
                :video="movie.question_recording"
              />
            </template>
            <div class="button-menu">
              <template v-if="!movie.question_recording">
                <button
                  class="button is-primary"
                  @click="stopRecording(idx)"
                  :disabled="!isRecording(idx)">
                  ■ 録画を終了
                </button>
              </template>
              <template v-else>
                <button
                  class="button is-danger"
                  @click="deleteRecording(idx)"
                  :disabled="isOtherRecording()">
                  × 録画を削除
                </button>
              </template>
              <button
                class="button is-primary"
                @click="createRecordingContent(idx)"
                :disabled="isMaxQuestionCount || isOtherRecording()">
                + 質問を追加
              </button>
              <button
                class="button is-danger"
                @click="deleteRecordingContent(idx)"
                :disabled="isNoDelete || isOtherRecording()">
                × 質問<b>{{idx + 1}}</b>を削除
              </button>
            </div>
            <b-dropdown class="speedup-list" aria-role="list" v-if="movie.question_recording">
              <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                  <span>× {{videoInfo[idx].speedRate}}</span>
                  <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
              </button>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.0, idx)">× 1.0</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.2, idx)">× 1.2</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.5, idx)">× 1.5</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.7, idx)">× 1.7</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(2.0, idx)">× 2.0</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button
        class="button"
        @click="cancel"
        :disabled="isOtherRecording()">
        キャンセル
      </button>
      <button
        class="button is-primary"
        @click="updateRecordingInterview(recordingInterview)"
        :disabled="isOtherRecording()">
        変更する
      </button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal        from '@/components/Modals/BasicModal'
import VideoRecording    from '@/functions/class/VideoRecording'
import RecordingVideoTag from '@/components/VideoView/organisms/RecordingVideoTag'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    BasicModal,
    RecordingVideoTag
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    tempRecordingInterview: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      MAX_QUESTION_COUNT: 10,
      videoInfo         : [],
      index             : 0,
      recordingInterview: null,
      timer             : 0,
      timerID           : null,
      mirrorImage       : true,
      recordingIndex    : null
    }
  },
  computed: {
    isNoDelete () {
      return this.recordingInterview.recording_content.length === 1
    },
    isMaxQuestionCount () {
      return this.recordingInterview.recording_content.length === this.MAX_QUESTION_COUNT
    },
  },
  created () {
    this.recordingInterview = this.$_.cloneDeep(this.tempRecordingInterview)
    this.recordingInterview.start_hhmm = new Date('2000/1/1 ' + (this.recordingInterview.start_hhmm ? this.recordingInterview.start_hhmm : '09:00') + ':00')
    this.recordingInterview.end_hhmm   = new Date('2000/1/1 ' + (this.recordingInterview.end_hhmm   ? this.recordingInterview.end_hhmm   : '18:00') + ':00')
    this.recordingInterview.total_limit_time = this.tempRecordingInterview.total_limit_time
    const initVideoInfo = {
      video         : null,
      speedRate     : 1.0,
      isCameraActive: false
    }
    for (let content in this.recordingInterview.recording_content) {
      this.videoInfo.push(initVideoInfo)
    }
  },
  watch: {
    timer () {
      if (this.recordingIndex !== null) {
        if (this.timer > 180) {
          this.stopRecording(this.recordingIndex)
          this.recordingIndex = null
        }
      }
    }
  },
  methods: {
    startTimer (index) {
      this.recordingIndex = index
      this.timerID = setInterval(() => {
        this.timer++
        this.$forceUpdate()
      }, 1000)
    },
    stopTimer () {
      clearInterval(this.timerID)
      this.timer = 0
      this.$forceUpdate()
    },
    getTitle () {
      if (this.recordingInterview) {
        return this.recordingInterview.name + '（質問数：' + this.recordingInterview.recording_content.length + '）'
      } else {
        return '-'
      }
    },
    cancel () {
      if (this.isOtherRecording()) {
        alert('録画中はキャンセルできません。録画を終了してからキャンセルボタンを押下して下さい。')
        return
      }
      let confirm = window.confirm('キャンセルすると変更途中のデータは保存されませんがよろしいでしょうか？')
      if (confirm) {
        this.cameraAllStop()
        this.$emit('cancel', false, this.tempRecordingInterview)
      }
    },
    changeSpeedRate (rate, index) {
      this.$nextTick(() => {
        let video = document.getElementById('question-' + index)
        video.playbackRate = rate
        this.videoInfo[index].speedRate = rate
      })
    },
    cameraSwitch (index) {
      if (this.videoInfo[index].isCameraActive) {
        this.createVideoElement(index)
      } else {
        if(this.videoInfo[index].video != null) {
          this.videoInfo[index].video.stopVideo()
          this.videoInfo[index].video = null
        }
      }
    },
    createVideoElement (index) {
      this.videoInfo[index].video = new VideoRecording (
        document.getElementById('question-' + index),
        1024,
        720
      )
    },
    startRecording (index) {
      if (this.timerID) {
        // タイマーが残っていることがあるのでクリア
        this.stopTimer()
      }
      if (!this.videoInfo[index].isCameraActive) {
        // カメラOFFなら撮影不可
        return
      }
      // 撮影開始
      if (this.videoInfo[index].video) {
        this.videoInfo[index].video.startRecording()
        this.startTimer()
        setTimeout(() => {
          this.$forceUpdate()
        }, 10)
      }
    },
    stopRecording (index) {
      if (this.videoInfo[index].video) {
        this.videoInfo[index].video.stopRecording()
        setTimeout(() => {
          this.recordingInterview
            .recording_content[index]
            .question_recording = this.videoInfo[index].video.getRecordingFile()
          this.stopTimer()
          this.videoInfo[index].video.stopVideo()
          this.videoInfo[index].video = null
          this.timer = 0
        }, 10)
      }
    },
    updateRecordingInterview (data) {
      // バリデーションで引っかかったら返す
      if (this.validationRecordingInterview(data)) {
        return
      }
      this.sendControlLog('録画面接　編集', '録画面接詳細画面にて、「変更する」ボタンをクリックした。')
      this.cameraAllStop()
      this.$emit('update-recording-interview', data)
      this.$emit('cancel', false, this.tempRecordingInterview)
    },
    validationRecordingInterview(data) {
      if (!data.name) {
        alert('動画面接名を入力してください。')
        return true
      }
      if (data.start_hhmm.getHours()   === data.end_hhmm.getHours()
        &&
          data.start_hhmm.getMinutes() === data.end_hhmm.getMinutes()
      ) {
        alert('面接可能時間帯の開始と終了時刻が同じです。見直しをお願い致します。')
        return true
      }
      for (const content of data.recording_content) {
        if (!content.name) {
          alert('質問' + (Number(content.order) + 1) + 'のタイトルを入力してください。')
          return true
        }
        if (!content.question_recording) {
          alert('質問' + (Number(content.order) + 1) + 'の録画データがございません。')
          return true
        }
      }
      return false
    },
    createRecordingContent (index) {
      const initVideoInfo = {
        video         : null,
        speedRate     : 1.0,
        isCameraActive: false
      }
      this.videoInfo.splice(index + 1, 0, initVideoInfo)
      this.recordingInterview.recording_content.splice(index + 1, 0, {
          name              : null,
          description       : null,
          answer_time       : 60,
          replayable_time   : 10,
          question_recording: null,
          order             : 0
        })
      this.orderRecordingContent()
      alert('質問を追加しました。')
    },
    deleteRecording (index) {
      let con = window.confirm('録画データを削除しますがよろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      con = window.confirm('録画データを削除しますと復元を行うことができませんが本当によろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      this.videoInfo[index].video          = null
      this.videoInfo[index].speedRate      = 1.0
      this.videoInfo[index].isCameraActive = false
      this.recordingInterview.recording_content[index].question_recording = null
    },
    deleteRecordingContent (index) {
      let con = window.confirm('質問を削除します。本質問で答えていただいた回答データも紐づいて削除されますがよろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      con = window.confirm('質問を削除しますと復元を行うことができませんが本当によろしいでしょうか？')
      if (!con) {
        alert('キャンセルしました。')
        return
      }
      this.recordingInterview.recording_content.splice(index, 1)
      this.videoInfo.splice(index, 1)
      this.orderRecordingContent()
    },
    orderRecordingContent () {
      for (let i in this.recordingInterview.recording_content) {
        this.recordingInterview.recording_content[i].order = i
      }
    },
    isRecording (index) {
      if (this.videoInfo[index].video != null) {
        if (this.videoInfo[index].video.getRecordingState() === 'recording') {
          return true
        }
      }
      return false
    },
    isOtherRecording () {
      for (const info of this.videoInfo) {
        if (info.video) {
          if (info.video.getRecordingState() === 'recording') {
            return true
          }
        }
      }
      return false
    },
    cameraAllStop () {
      for (let index in this.videoInfo) {
        this.stopTimer()
        if (this.videoInfo[index].video != null) {
          this.videoInfo[index].video.stopVideo()
          this.videoInfo[index].video = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 24px;
  height: 75vh;
  overflow: auto;
}
.-container::-webkit-scrollbar {
  width: 8px;
}
.input-field {
  padding: 8px;
  text-align: left;
  p {
    font-weight: 600;
    margin-bottom: 8px;
  }
}
.time-field {
  display: flex;
  align-items: center;
  .-time {
    width: 120px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.video-wrapper {
  position: relative;
  width: 100%;
  height: 300px;
  margin-top: 8px;
  background: #444;
  margin-bottom: 24px;
  .video-flip {
    transform: scale(-1, 1);
  }
  .video-back {
    width: 100%;
    height: 300px;
    background: #444;
  }
  .start-button {
    position: absolute;
    top: 0;
    cursor: pointer;
    color: white;
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: 0.5s;
    p {
      font-size: 18px;
      transition: 0.5s;
    }
    .desc {
      font-size: 13px;
      transition: 0.5s;
    }
  }
  .start-button:hover {
    p {
      font-size: 24px;
    }
    .desc {
      font-size: 16px;
      transition: 0.5s;
    }
  }
  .next-button {
    position: absolute;
    width: 48px;
    height: 48px;
    background: #22222222;
    color: white;
    border-radius: 50%;
    border: solid 2px #ccc;
    top: 50%;
    right: -16px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    padding: 0;
    font-size: 36px;
  }
  .prev-button {
    position: absolute;
    width: 48px;
    height: 48px;
    background: #22222222;
    color: white;
    border-radius: 50%;
    border: solid 2px #ccc;
    top: 50%;
    left: 32px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    padding: 0;
    font-size: 36px;
  }
  .button-menu {
    width: 100%;
    display: flex;
    justify-content: space-between;
    button {
      width: 30%;
    }
  }
  .question-title {
    position: absolute;
    font-size: 32px;
    top: 0;
    left: 0;
    color: white;
    padding: 4px 8px;
  }
  .speedup-list {
    position: absolute;
    top: 0;
    right: 0;
    padding: 4px 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoView/organisms/ModalEditRecord.vue